import Button from 'common/components/Button';
import CenteredCardLayout from 'common/layouts/CenteredCardLayout';
import config from 'config';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from './index.module.scss';

function Login() {
  const [searchParams] = useSearchParams();

  const doLogin = async () => {
    window.location.href = `${config.whoopIdUrl}/sign-in?for=${config.appUrl}${(searchParams.get('redir') || '/')}`;
  }

  return (
    <>
      <h2 className={styles.signInText}>Sign in to WHOOP</h2>
        <Button
          onClick={() => {
            doLogin();
          }}
          label="Sign in"
          variant="primary"
          theme="dark"
          type="submit"
          className={styles.signInButton}
          data-testid="sign-in-button"
        />
    </>
  )
}

export default () => (
  <CenteredCardLayout>
    <Login />
  </CenteredCardLayout>
);
